import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, NgModel } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { DataTypeComponent } from '../../../../data-type-component';
import { FieldConfigDTO, LookupEntityConf } from '../../../../../../../system/system-dtos';
import { LookupService } from '../../lookup.service';
import { LookupModalComponent, LookupModalInitialData } from '../../lookup-modal/lookup-modal.component';
import { GameSearchModalComponent } from '../../game-search-modal/game-search-modal.component';
import { GAME_SEARCH_DIALOG_CONFIG } from '../../game-search-modal/game-search-modal.config';
import {
  MyErrorStateMatcher,
  ValidatorConfig,
} from '../../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../../common/field-validation/ui-validator.dto';
import { BlastV2Service } from '../../../../../../views/main-table-v2/service/blast-v2.service';
import { isDefined } from '../../../../../../utils/utils';

const GAME_LOOKUP_CODES = new Set(['game_instance']);

@Component({
  selector: 'app-multi-lookup-from-field',
  templateUrl: './multi-lookup-from-field.component.html',
  styleUrls: ['./multi-lookup-from-field.component.scss'],
  standalone: false,
})
export class MultiLookupFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() data: any;

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  @Input() lookup: string;

  @Input() fieldName: any;

  list: any[] = [];

  lookupCode = '';

  private lookupConfig: LookupEntityConf;

  matcher = new MyErrorStateMatcher();

  private validatorsSet = false;

  public externalUrl: string;

  constructor(
    private lookupService: LookupService,
    private dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private blastService: BlastV2Service
  ) {
    super();
  }

  ngOnInit() {
    this.lookupCode = this.getLookupcode();
    this.lookupConfig = this.lookupService.getConfByLookupCode(this.getLookupcode());
    if (this.formGroup) {
      if (!this.data || typeof this.data === 'string') {
        const id = this.data ? this.data : this.formGroup.get(this.getFieldName()).value;
        if (!id) {
          return;
        }
        this.blastService.getCollectionObservable(this.getLookupcode()).subscribe((list) => {
          this.data = list ? list.find((d) => d[this.fieldConfig.idFieldName] == id) : this.data;
        });
      }
    }
    this.list = this.data ? JSON.parse(JSON.stringify(this.data)) : [];
    this.externalUrl = this.getExternalUrl();
  }

  public extractLabel(data: any) {
    if (isDefined(data) && isDefined(this.lookupConfig.extractLabel)) {
      const func = new Function('self', 'data', this.lookupConfig.extractLabel);
      const val = func(this, data);
      return val;
    }
    return undefined;
    // return data ? this.lookupConfig.extractLabel(data) : undefined;
  }

  private getLookupcode() {
    return this.lookup ? this.lookup : this.fieldConfig.lookup;
  }

  openModal() {
    const matDialogRef = this.isGameLookup()
      ? this.dialog.open(GameSearchModalComponent, GAME_SEARCH_DIALOG_CONFIG)
      : this.dialog.open(LookupModalComponent, {
          minWidth: '400px',
          data: {
            lookup: this.getLookupcode(),
            fieldConfig: this.fieldConfig,
            context: this.formGroup.getRawValue(),
            returnAll: true,
          } as LookupModalInitialData,
        });

    matDialogRef
      .afterClosed()
      .pipe(filter((ret) => !!ret))
      .subscribe((ret) => {
        const tempList: any[] = JSON.parse(JSON.stringify(this.list));
        if (ret instanceof Array) {
          ret.forEach((r) => tempList.push(r));
        } else {
          tempList.push(ret);
        }

        const tempSet = new Set(
          tempList.map((element) => {
            const func = new Function('self', 'data', this.lookupConfig.uniqueId);
            return func(this, element);
          })
        );

        this.list = [];
        tempSet.forEach((id) => {
          this.list.push(
            tempList.filter((el) => {
              const func = new Function('self', 'data', this.lookupConfig.uniqueId);
              const res = func(this, el);
              return res === id;
            })[0]
          );
        });

        const fieldName = this.getFieldName();
        this.formGroup.get(fieldName).setValue(this.list);
        this.ref.markForCheck();
      });
  }

  private isGameLookup(): boolean {
    const lookupCode = this.getLookupcode();
    if (GAME_LOOKUP_CODES.has(lookupCode)) {
      return true;
    }

    const selectUrl = this.fieldConfig?.selectUrl || this.lookupConfig?.defaultSelectUrl || '';
    return selectUrl.includes('/game/casinofreespinlookup') || selectUrl.includes('/game/casinolookup');
  }

  private getFieldName() {
    return this.fieldName ? this.fieldName : this.fieldConfig.name;
  }

  condition(v: UiValidator, ngModel: NgModel) {
    if (!this.validatorsSet) {
      this.validatorsSet = true;
      ngModel.control.setValidators(MyErrorStateMatcher.convertToAngularValidators([this.fieldConfig]));
    }

    return this.getValidatorConfig(v).condition(ngModel.control);
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  public getExternalUrl(): string {
    const { data } = this;

    if (!this.lookupConfig.externalUrl) {
      return null;
    }
    return eval(this.lookupConfig.externalUrl);
  }

  remove(item: any, index: number) {
    this.list.splice(index, 1);
    const fieldName = this.getFieldName();
    this.formGroup.get(fieldName).setValue(this.list);
  }
}
